import { lazy } from 'react';

const Fleet = lazy(() => import('./page'));

export default Fleet;
